import { pages } from "../pages";

declare const window: CustomWindow;
declare const globalThis: CustomWindow;

export type CustomWindow = Window & {
	renderPage: (pageName: keyof typeof pages) => Promise<void>;
};

const w = globalThis ?? window;

export { w as window };
